//valores iniciales de la sesion de usuario
export const initialState = {
  usuario: {
    name: "",
    surname: "",
    email: "",
    phone: "",
    id: "",
    photo: ""
  },
  signin: false
};
//cambia los valores del estado inicial
const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "START_SESSION":
      return {
        ...state,
        usuario: action.sesion,
        signin: action.signin
      };
    case "CHANGE_SESSION":
      return {
        ...state,
        usuario: action.newuser,
        signin: action.signin
      };
    case "CLOSE_SESSION":
      return {
        ...state,
        usuario: action.newuser,
        signin: action.signin
      };
    default:
      return state;
  }
};

export default sessionReducer;
